import { isThemeMode, type ThemeMode } from '@/modern/theme/colorScheme';

import { withMixpanel } from './mixpanel';

export type Theme = ThemeMode;

const THEME_PROPERTY = 'theme';
const THEME_CHANGE_EVENT = 'theme_changed';
// Same localStorage key the ColorModeProvider persists the color scheme under.
const THEME_LS_KEY = 'dnk-mode';

export const getCurrentTheme = (): Theme => {
  if (typeof window === 'undefined') return 'light';
  const stored = window.localStorage.getItem(THEME_LS_KEY);
  return isThemeMode(stored) ? stored : 'light';
};

export const setThemeProperty = (theme: Theme): void => {
  withMixpanel('setThemeProperty', (mixpanel) => {
    mixpanel.register({ [THEME_PROPERTY]: theme });
    if (typeof mixpanel.people?.set === 'function') {
      mixpanel.people.set({ [THEME_PROPERTY]: theme });
    }
  });
};

export const recordThemeChange = (next: Theme): void => {
  const previous = getCurrentTheme();
  setThemeProperty(next);
  if (previous !== next) {
    withMixpanel('recordThemeChange', (mixpanel) => {
      mixpanel.track(THEME_CHANGE_EVENT, { from: previous, to: next });
    });
  }
};
